import { match, P } from "ts-pattern";

export type FilterByType = "classic" | "expeditions" | undefined;

export const filterByShipType = <T extends { shipType?: string }>(
  data: T[],
  filterByType: FilterByType
): T[] => {
  return match(filterByType)
    .with("expeditions", () => data.filter((s) => s.shipType == "Expedition"))
    .with("classic", () => data.filter((s) => s.shipType == "Classic"))
    .with(P.nullish, () => data)
    .exhaustive();
};

export const filterByDestinationType = <
  T extends { isExpeditionDestination?: boolean; fullPath?: string }
>(
  data: T[],
  filterByType: FilterByType
): T[] => {
  return match(filterByType)
    .with("expeditions", () => {
      const expeditionFYCFilter = `?toggle%5BcruiseType%5D=true`;

      return data
        .filter((n) => n.isExpeditionDestination == true)
        .map((d) => {
          return {
            ...d,
            fullPath: `${d.fullPath}${expeditionFYCFilter}`
          };
        });
    })
    .with("classic", () =>
      data.filter((n) => n.isExpeditionDestination !== true)
    )
    .with(P.nullish, () => data)
    .exhaustive();
};
